import { render, staticRenderFns } from "./BlogItemHeader.vue?vue&type=template&id=66ac2981&"
import script from "./BlogItemHeader.vue?vue&type=script&lang=js&"
export * from "./BlogItemHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports